module.exports = __webpack_public_path__ + "img/image_8.ff15aa4c.png";